import { useContext } from "react"
import TeamContext from "../context/TeamContext"


function SearchBar() {

    // Get variables from context
    const {getStats, handleConferenceChange, handleDivisionChange, handleTeamChange, handleYearChange, conference, division, team, year} = useContext(TeamContext)
    const conferences = ["Please Select Conference", "AFC", "NFC"]
    const divisions = ["Please Select Division","North", "East", "South", "West"]
    const nfcNorth = ['Please Select Team','Bears', 'Lions', 'Packers', 'Vikings']
    const nfcSouth = ['Please Select Team','Falcons', 'Panthers', 'Saints', 'Buccaneers']
    const nfcEast = ['Please Select Team','Eagles','Cowboys','Giants','Commanders']
    const nfcWest = ['Please Select Team','Cardinals', 'Rams','49ers','Seahawks' ]
    const afcNorth = ['Please Select Team','Bengals', 'Steelers', 'Ravens', 'Browns']
    const afcWest = ['Please Select Team','Broncos', 'Chiefs', 'Raiders', 'Chargers']
    const afcEast = ['Please Select Team','Bills', 'Dolphins', 'Patriots', 'Jets']
    const afcSouth = ['Please Select Team','Texans', 'Colts', 'Jaguars', 'Titans']
    const years = ['Please Select Year', '2022', '2021', '2020', '2019', '2018', '2017', '2016', '2015', '2014', '2013', '2012', '2011', '2010', '2009', '2008', '2007', '2006', '2005', '2004', '2003', '2002', '2001', '2000', '1999', '1998', '1997', '1996', '1995', '1994', '1993', '1992', '1991', '1990', '1989', '1988', '1987', '1986', '1985', '1984', '1983', '1982', '1981', '1980']

    const selectDivision = () => {
        if(conference === 'select-conference') {
            return <option disabled='disabled'>Please Select Division</option>
        } else if(conference === 'AFC' || 'NFC') {
            return divisions.map((division, idx) => (<option defaultValue={'Please Select Division'} key={idx}>{division}</option>))
        }

    }


    const selectTeam = () => {
        if(conference === 'select-conference' || division === 'select-division' || conference === 'Please Select Conference' || division === 'Please Select Division') {
            return <option disabled='disabled'>Please Select Team</option>
        } else if(conference === 'AFC' && division === 'North') {
            return afcNorth.map((team, idx) => (<option key={idx}>{team}</option>))
        } else if(conference === 'AFC' && division === 'South') {
            return afcSouth.map((team, idx) => (<option key={idx}>{team}</option>))
        } else if(conference === 'AFC' && division === 'East') {
            return afcEast.map((team, idx) => (<option  key={idx}>{team}</option>))
        } else if(conference === 'AFC' && division === 'West') {
            return afcWest.map((team, idx) => (<option  key={idx}>{team}</option>))
        } else if(conference === 'NFC' && division === 'North') {
            return nfcNorth.map((team, idx) => (<option  key={idx}>{team}</option>))
        } else if(conference === 'NFC' && division === 'South') {
            return nfcSouth.map((team, idx) => (<option  key={idx}>{team}</option>))
        } else if(conference === 'NFC' && division === 'East') {
            return nfcEast.map((team, idx) => (<option  key={idx}>{team}</option>))
        } else if(conference === 'NFC' && division === 'West') {
            return nfcWest.map((team, idx) => (<option  key={idx}>{team}</option>))
        } 
    }

    const selectYear = () => {
        if(conference === 'select-conference') {
            return <option disabled='disabled'>Please Select Year</option>
        } else {
            return years.map((year, idx) => (<option defaultValue={'Please Select Year'} key={idx}>{year}</option>))
        }
    }


    return (
        <nav className={"xl:flex px-2 justify-between items-center bg-primary shadow-lg mb-4 " + (team != 'select-team' ? team : '') + (team === '49ers' ? ' niners' : '')}>
            <h1 className="underline russo-one text-3xl text-white text-center pt-2">NFL STAT TRACKER</h1>
            <div className="selection mx-auto align-center text-center justify-around flex-col mx-auto py-4 xl:flex lg:flex-row xl:items-center lg:flex-1 lg:items-center md:flex">
                <div className="p-2">
                    <select className="bg-black p-0.5 text-white rounded-sm cursor-pointer" onChange={handleConferenceChange}>
                        {conferences.map((conference, idx) => (
                            <option key={idx}>{conference}</option>
                        ))}
                    </select>
                </div>
                <div className="p-2">
                    <select className="bg-black p-0.5 text-white rounded-sm cursor-pointer" onChange={handleDivisionChange} defaultValue='Please Select Division'>
                        {selectDivision()}
                    </select>
                </div>
                <div className="p-2">
                    <select className="bg-black p-0.5 text-white cursor-pointer" onChange={handleTeamChange} defaultValue='Please Select Team'>
                            {selectTeam()}
                    </select>
                </div>
                <div className="p-2">
                    <select className="bg-black p-0.5 text-white cursor-pointer" onChange={handleYearChange} defaultValue='Please Select Year'>
                            {selectYear()}
                    </select>
                </div>
                <button disabled={year === 'select-year' || year === 'Please Select Year' || team === 'select-team' || team === 'Please Select Team' || division === 'select-division' || division === 'Please Select Division' || conference === 'select-conference' || conference === 'Please Select Conference'} onClick={getStats} className={"btn text-white bg-black " + (team != 'select-team' ? `${team}-secondary` : '') + (team === '49ers' ? ' niners-secondary' : '')}>Get Stats</button>
            </div>
        </nav>
    )
}

export default SearchBar
